import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Flex from '../../Flex';
import Loader from '../../Loader';
import styles from '../index.module.scss';
var SYSTEM_PROPS = [];
var SuggestionContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      loading = _ref.loading,
      isOpen = _ref.isOpen;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx((_cx = {}, _cx[styles.containerOpen] = isOpen, _cx[styles.containerRoot] = !isOpen, _cx[styles.containerIsLoading] = loading, _cx))
  }, loading && /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "flex-end",
    position: "absolute",
    width: "full",
    p: 3,
    top: 0,
    bottom: 0,
    className: styles.loader
  }, /*#__PURE__*/React.createElement(Loader, null)), children);
});
SuggestionContainer.displayName = 'SuggestionContainer';
SuggestionContainer.identifier = SuggestionContainer.displayName; // used in docs website

SuggestionContainer.clonableProps = SYSTEM_PROPS;
SuggestionContainer.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool
};
export default SuggestionContainer;